import * as React from 'react';
import { ActivityIndicator } from "../ActivityIndicator";
import { theme } from '../../theme';
import styled from 'styled-components/native';
import { Column } from '../Column';
import { Text } from '../Text';
import { useSync } from '../../data/syncHooks';
import { formatDownloadStatus } from '../../data/downloadProgress';

const ProgressTrack = styled.View<{ compact?: boolean }>`
  width: ${(props) => props.compact ? '34px' : '180px'};
  height: 4px;
  overflow: hidden;
  border-radius: 4px;
  background-color: ${(props) => props.theme.palette.lineColor};
  margin-top: ${(props) => props.theme.spacing.xs};
`;

const ProgressFill = styled.View<{ percent: number }>`
  height: 4px;
  width: ${(props) => props.percent}%;
  background-color: ${(props) => props.theme.palette.primary};
`;

function getPercent(recordsDownloaded: number, totalRecords: number) {
  if (!totalRecords) {
    return 0;
  }

  return Math.max(0, Math.min(100, Math.round((recordsDownloaded / totalRecords) * 100)));
}

export const SyncIndicator = (props: { compact?: boolean }) => {
  const { downloadProgress } = useSync();
  const percent = getPercent(downloadProgress.recordsDownloaded, downloadProgress.totalRecords);
  const showDetails = !props.compact && (downloadProgress.status === 'starting' || downloadProgress.status === 'downloading');

  return (
    <Column alignX="center">
      <ActivityIndicator size={'large'} color={theme.palette.primary} />
      <ProgressTrack compact={props.compact}>
        <ProgressFill percent={percent} />
      </ProgressTrack>
      {showDetails && (
        <Text size='xs' color='secondary' alignX='center' marginTop='xs'>
          {formatDownloadStatus(downloadProgress)}
        </Text>
      )}
    </Column>
  );
}
